import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=49773a2c"
import script from "./accountDetail.vue?vue&type=script&lang=js"
export * from "./accountDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports